import { render, staticRenderFns } from "./form-employees-chat.vue?vue&type=template&id=1f92cbd4&"
import script from "./form-employees-chat.vue?vue&type=script&lang=js&"
export * from "./form-employees-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports